export default __webpack_public_path__ + "static/media/029-parsley.7323f71f.svg";